// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .leftbar-item {
  padding: 3px 0px 1px 0px;
  display: flow-root;
}
:host .leftbar-item-active {
  background-color: var(--toolboxItemActiveBackground);
  color: var(--toolboxItemActiveColor);
}
:host .leftbar-item span {
  float: left;
}
:host .leftbar-item .leftbar-item-type {
  float: left;
  padding-left: 4px;
  font-size: 16px;
  line-height: 20px;
}
:host .leftbar-item mat-icon {
  float: right;
  font-size: 18px;
}
:host .view-item-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 54px);
}
:host .item-icon-view {
  color: #7CACF8;
}
:host .item-icon-cards {
  color: #F8A57C;
}
:host .item-icon-maps {
  color: #37BE5F;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/editor-views-list/editor-views-list.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/editor-views-list/editor-views-list.component.scss"],"names":[],"mappings":"AACI;EACI,wBAAA;EACA,kBAAA;ACAR;ADGI;EACI,oDAAA;EACA,oCAAA;ACDR;ADII;EACI,WAAA;ACFR;ADKI;EACI,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;ACHR;ADMI;EACI,YAAA;EACA,eAAA;ACJR;ADOI;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;ACLR;ADQI;EACI,cAAA;ACNR;ADSI;EACI,cAAA;ACPR;ADUI;EACI,cAAA;ACRR","sourcesContent":[":host {\n    .leftbar-item {\n        padding: 3px 0px 1px 0px;\n        display: flow-root;\n    }\n\n    .leftbar-item-active {\n        background-color: var(--toolboxItemActiveBackground);\n        color: var(--toolboxItemActiveColor);\n    }\n\n    .leftbar-item span {\n        float: left;\n    }\n\n    .leftbar-item .leftbar-item-type {\n        float: left;\n        padding-left: 4px;\n        font-size: 16px;\n        line-height: 20px;\n    }\n\n    .leftbar-item mat-icon {\n        float: right;\n        font-size: 18px;\n    }\n\n    .view-item-text {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: calc(100% - 54px);\n    }\n\n    .item-icon-view {\n        color: #7CACF8;\n    }\n\n    .item-icon-cards {\n        color: #F8A57C;\n    }\n\n    .item-icon-maps {\n        color: #37BE5F;\n    }\n}",":host .leftbar-item {\n  padding: 3px 0px 1px 0px;\n  display: flow-root;\n}\n:host .leftbar-item-active {\n  background-color: var(--toolboxItemActiveBackground);\n  color: var(--toolboxItemActiveColor);\n}\n:host .leftbar-item span {\n  float: left;\n}\n:host .leftbar-item .leftbar-item-type {\n  float: left;\n  padding-left: 4px;\n  font-size: 16px;\n  line-height: 20px;\n}\n:host .leftbar-item mat-icon {\n  float: right;\n  font-size: 18px;\n}\n:host .view-item-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(100% - 54px);\n}\n:host .item-icon-view {\n  color: #7CACF8;\n}\n:host .item-icon-cards {\n  color: #F8A57C;\n}\n:host .item-icon-maps {\n  color: #37BE5F;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
